var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3585 8.57839L12.6355 0.204688C12.2748 -0.0682294 11.7874 -0.0682294 11.4267 0.204688L0.703689 8.57839C0.469742 8.76361 0.333313 9.04628 0.333313 9.34847V23.2591C0.333313 23.6685 0.664717 24 1.07412 24H3.31625C3.72566 24 4.05706 23.6685 4.05706 23.2591V13.6377C4.05706 13.1015 4.49574 12.6629 5.03188 12.6629H19.0303C19.5664 12.6629 20.0051 13.1015 20.0051 13.6377V23.2591C20.0051 23.6685 20.3365 24 20.746 24H22.988C23.3975 24 23.7289 23.6685 23.7289 23.2591V9.34847C23.7289 9.04628 23.5924 8.76361 23.3585 8.57839ZM12.0311 8.49063C10.9588 8.49063 10.0815 7.61333 10.0815 6.53124C10.0815 5.45897 10.9588 4.58161 12.0311 4.58161C13.1034 4.58161 13.9807 5.45897 13.9807 6.53124C13.9807 7.61333 13.1034 8.49063 12.0311 8.49063Z",
    fill: "#1676F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyer);
export default __webpack_public_path__ + "static/media/buyer.178a81709e2587e5095c076baa39b1a2.svg";
export { ForwardRef as ReactComponent };